module.exports = __webpack_public_path__ + "img/19.43de6417.jpeg";